export default __webpack_public_path__ + "38f4657bd52fd7f96f8b7ddd7945b96d.png";